import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { SubscriptionRepository } from "../domain/SubscriptionRepository";
import { CompanyId } from "~/context/Company/domain/CompanyId";
import { SubscriptionId } from "../domain/SubscriptionId";
import { SubscriptionDomain } from "../domain/SubscriptionDomain";

export async function addSubscription(
  repository: SubscriptionRepository,
  companyId: string,
  type: string,
): Promise<VectiResult> {
  const myCompanyId = new CompanyId(companyId);
  const mySubscriptionId = SubscriptionId.random();

  try {
    const result = await repository.addSubscription({
      uid: mySubscriptionId,
      company_uid: myCompanyId,
      subscription_creation_date: new Date(),
      subscription_end_date: new Date(),
      subscription_status: SubscriptionDomain.started,
      subscription_plan: type,
      subscription_is_active: false,
      subscription_payment_method: SubscriptionDomain.getPaymentMethod("CL"),
    });
    console.log("addSubscription", JSON.stringify(result));
    return new VectiResult(true, '{"uid":"' + mySubscriptionId.toString() + '"}');
  } catch (error) {
    console.log("error addSubscription:" + error);
    return new VectiResult(false, "Error");
  }
}
